import config from "@/config"
import http from "@/utils/request"

export default {
	testHeaders: {
		name: "测试案例列的数据集合",
		get: function (versionNum, projectNum) {
			const url = `${config.API_URL}/lqa-game/project/testCaseConfig/config/getDefault`;
			return http.get(url,{ projectNum, versionNum });
		},
		update: function (id, value) {
			const url = `${config.API_URL}/lqa-game/project/testCaseConfig/config`;
			return http.put(url, { id, showName: value });
		}
	},
	batchAddTestList: {
		url: `${config.API_URL}/lqa-game/system/test/batchAdd`,
		name: "批量添加测试案例",
		post: function (data) {
			return http.post(this.url, data, {timeout: 1000 * 180});
		}
	},
	// 批量编辑测试案例
	batchEditTestList: {
		post: function (data) {
			return http.post("/lqa-game/system/test/batchAddNew", data, {
				timeout: 1000 * 180
			});
		}
	},
	getTaskList: {
		url: `${config.API_URL}/lqa-game/system/taskInfo/table`,
		name: "获取任务信息",
		post: function (params) {
			return http.post(this.url, params);
		}
	},
	getTaskProcess: {
		url: `${config.API_URL}/lqa-game/system/taskInfo/getTaskProcess`,
		name: "获取任务完成进度",
		get: function (taskId, type) {
			return http.get(`${this.url}?taskId=${taskId}&taskType=${type}`);
		}
	},
	getTaskInfoById: {
		url: `${config.API_URL}/lqa-game/system/taskInfo/`,
		name: "获取任务信息",
		get: function (params) {
			return http.get(this.url + params);
		}
	},
	getTaskInfoByTestId: {
		url: `${config.API_URL}/lqa-game/system/test/getTaskInfoByTestId/`,
		name: "获取任务信息",
		get: function (id) {
			return http.get(this.url + id);
		}
	},
	getTaskDealCount:{
		url: `${config.API_URL}/lqa-game/system/taskInfo/getTaskDealCount?versionNum=`,
		name: "获取任务待办和已办总量",
		get: function (params) {
			return http.get(this.url + params);
		}
	},
	getTaskUser: {
		url: `${config.API_URL}/lqa-game/system/taskInfo/getTaskUsers?projectNum=`,
		name: "获取任务相关人员信息",
		get: function (param1,param2) {
			return http.get(this.url + param1+'&target='+param2);
		}
	},
	checkTaskName: {
		url: `${config.API_URL}/lqa-game/system/taskInfo/checkTaskName?projectNum=`,
		name: "获取任务信息",
		get: function (params1,param2) {
			return http.get(this.url + params1+"&taskName="+param2);
		}
	},
	
	exportTaskExcel: {
		url: `${config.API_URL}/lqa-game/system/taskInfo/export`,
		name: "获取所有任务看板信息",
		post: function (params) {
			return http.post(this.url ,params);

		},
	},
	taskStatusCount: {
		url: `${config.API_URL}/lqa-game/system/taskInfo/getTaskBoardCount?versionNum=`,
		name: "获取所有任务看板信息",
		get: function (projectNum,taskName) {
			return http.get(this.url + projectNum + "&taskName="+taskName);

		},
	},
	
	getTaskFile: {
		url: `${config.API_URL}/lqa-game/system/taskInfo/getTaskFile?taskId=`,
		name: "获取BUG附件",
		get: function(param1){
			return http.get(this.url+param1);
		}
	},
	removeFileInfo: {
		url: `${config.API_URL}/lqa-game/system/taskInfo/removeImageInfo?fileId=`,
		name: "删除附件",
		get: function(param1){
			return http.get(this.url+param1);
		}
	},
	relaAllModual:{
		url: `${config.API_URL}/lqa-game/system/taskInfo/relationAll`,
		name: "获取所有任务看板信息",
		post: function (data) {
			return http.post(this.url , data);

		},
	},
	sceen:{
		url: `${config.API_URL}/lqa-game/system/taskInfo/sceen`,
		name: "获取所有任务看板信息",
		get: function () {
			return http.get(this.url);

		},
	},
	dealMyTask:{
		url: `${config.API_URL}/lqa-game/system/taskInfo/dealTask`,
		name: "处理我的任务-已完成",
		post: function (data) {
			return http.post(this.url , data);

		},
	},
	// 获取当前任务所有测试案例列表信息
	getAllTaskCaseColumn: {
		url: `${config.API_URL}/lqa-game/system/testcase/checkCaseValue`,
		name: "获取当前任务所有测试案例信息",
		get: function (taskId) {
			return http.get(this.url + `?taskId=${taskId}`);
		}
	},
	// 获取当前任务所有测试案例信息
	getAllTaskCase: {
		url: `${config.API_URL}/lqa-game/system/testcase/getAllTaskCaseByTid`,
		name: "获取当前任务所有测试案例信息",
		get: function (taskId) {
			return http.get(this.url + `?taskId=${taskId}`);
		}
	},
	// 获取当前任务所有测试案例信息
	upgradeTaskCaseItem: {
		url: `${config.API_URL}/lqa-game/system/test/edit`,
		name: "获取当前任务所有测试案例信息",
		put: function (data) {
			return http.post(this.url, data);
		}
	},
	getTaskCase: {
		url: `${config.API_URL}/lqa-game/system/testcase/getTestCaseInfo?projectNum=`,
		name: "获取任务相关测试用例信息",
		get: function (params) {
			return http.get(this.url + params);
		}
	},
	getTaskCaseTable: {
		url: `${config.API_URL}/lqa-game/system/testcase/getTestCaseTable`,
		name: "获取任务相关测试用例信息",
		get: function (params) {
			return http.get(this.url, params);
		}
	},
	getTaskCaseList: {
		url: `${config.API_URL}/lqa-game/system/testcase/list`,
		name: "获取任务相关测试用例信息",
		get: function (params) {
			return http.get(this.url, params);
		}
	},
	getTaskCaseByTaskId: {
		url: `${config.API_URL}/lqa-game/system/testcase/getTaskTestCaseInfo?taskId=`,
		name: "获取任务相关测试用例信息",
		get: function (params) {
			return http.get(this.url + params);
		}
	},
	removeTaskCaseRelation: {
		url: `${config.API_URL}/lqa-game/system/test/removeTest?taskId=`,
		name: "获取任务相关测试用例信息",
		get: function (params,params2) {
			return http.get(this.url + params+'&testId='+params2);
		}
	},
	removeImageRelation: {
		url: `${config.API_URL}/lqa-game/system/test/removeImage?taskId=`,
		name: "获取任务相关测试用例信息",
		get: function (params,params2) {
			return http.get(this.url + params+'&taskFileId='+params2);
		}
	},
	saveTestTest: {
		url: `${config.API_URL}/lqa-game/system/test/saveTest`,
		name: "添加测试用例与测试关联项",
		post: function (data) {
			return http.post(this.url, data);
		}
	},
	saveTestFile: {
		url: `${config.API_URL}/lqa-game/system/test/saveFile`,
		name: "添加测试用例与测试关联项",
		post: function (data) {
			return http.post(this.url, data);
		}
	},
	saveBatchTest: {
		url: `${config.API_URL}/lqa-game/system/test/saveBatchTest`,
		name: "添加测试用例与测试关联项",
		post: function (data) {
			return http.post(this.url, data);
		}
	},
	saveBatchFile: {
		url: `${config.API_URL}/lqa-game/system/test/saveBatchFile`,
		name: "添加测试用例与测试关联项",
		post: function (data) {
			return http.post(this.url, data);
		}
	},
	addTestInfo: {
		url: `${config.API_URL}/lqa-game/system/taskInfo`,
		name: "添加测试用例与测试关联项",
		post: function (data) {
			return http.post(this.url, data);
		}
	},
	updateTestInfo: {
		url: `${config.API_URL}/lqa-game/system/taskInfo`,
		name: "修改测试用例与测试关联项",
		put: function (data) {
			return http.put(this.url, data);
		}
	},
	updateTestInfoByOne: {
		url: `${config.API_URL}/lqa-game/system/taskInfo/update`,
		name: "修改测试用例与测试关联项",
		put: function (data) {
			return http.put(this.url, data);
		}
	},
	uploadImageInfo: {
		url: `${config.API_URL}/lqa-game/system/taskInfo/addImageInfo`,
		name: "修改测试用例与测试关联项",
		post: function (data) {
			return http.post(this.url, data);
		}
	},
	
	haveRead: {
		url: `${config.API_URL}/lqa-game/system/taskInfo/haveRead?taskId=`,
		name: "修改测试用例与测试关联项",
		get: function (param) {
			return http.get(this.url + param);
		}
	},
	deleteTaskInfo: {
		url: `${config.API_URL}/lqa-game/system/taskInfo/`,
		name: "修改测试用例与测试关联项",
		delete: function (taskid) {
			return http.delete(this.url + taskid);
		}
	},
	//测试用例与测试关联项
	addTestCaseTest: {
		url: `${config.API_URL}/lqa-game/system/test`,
		name: "添加测试用例与测试关联项",
		post: function (data) {
			return http.post(this.url, data);
		}
	},
	addImageFileList: {
		url: `${config.API_URL}/lqa-game/system/test/addImageFileList`,
		name: "添加测试用例与测试关联项",
		post: function (data) {
			return http.post(this.url, data);
		}
	},
	deleteTestCaseTest: {
		url: `${config.API_URL}/lqa-game/system/test/`,
		name: "删除测试用例与测试关联项",
		delete: function (data) {
			return http.delete(this.url + data);
		}
	},
	testCaseTestUpdate: {
		url: `${config.API_URL}/lqa-game/system/test`,
		name: "修改测试用例与测试关联项",
		put: function (data) {
			return http.put(this.url, data);
		}
	},
	getAllTaskFileCount:{
		url: `${config.API_URL}/lqa-game/system/test`,
		name: "查询所有附件关联项",
		put: function (data) {
			return http.put(this.url, data);
		}
	},
	getTaskFileByModula: {
		url: `${config.API_URL}/lqa-game/system/taskInfo/getTaskFilesByModula`,
		name: "获取任务附件信息关联信息",
		post: function (data) {
			return http.post(this.url, data);
		}
	},
	getTaskTestByModula: {
		url: `${config.API_URL}/lqa-game/system/taskInfo/getTaskTestByModula`,
		name: "获取任务附件信息关联信息",
		post: function (data) {
			return http.post(this.url, data);
		}
	},
	getAllTaskFilePage: {
		url: `${config.API_URL}/lqa-game/system/taskFile/taskFilelist`,
		name: "获取任务附件信息",
		get: function (params) {
			return http.get(this.url, params);
		}
	},
	getMyTaskInfo: {
		url: `${config.API_URL}/lqa-game/system/taskFile/myUploadlist`,
		name: "获取任务附件信息",
		get: function (params) {
			return http.get(this.url, params);
		}
	},
	
	getAllTaskFile: {
		url: `${config.API_URL}/lqa-game/system/taskInfo/getAllTaskFiles?taskId=`,
		name: "获取任务附件信息，传入Taskid或versionNum",
		get: function (params) {
			return http.get(this.url + params);
		}
	},
	getMyTaskFilePage: {
		url: `${config.API_URL}/lqa-game/system/taskFile/myTaskFiles`,
		name: "获取任务附件信息",
		get: function (params) {
			return http.get(this.url, params);
		}
	},
	getMyTaskList: {
		url: `${config.API_URL}/lqa-game/system/taskInfo/getMyTask`,
		name: "获取任务附件信息",
		post: function (params) {
			return http.post(this.url, params);
		}
	},
	taskImage: {
		imageFile: {
			url: `${config.API_URL}/lqa-game/system/taskFile/myTaskImages?versionNum=`,
			name: "获取所有图片信息",
			get: function (versionNum, taskId) {
				return http.get(this.url + versionNum + "&taskId=" + taskId);
			}
		},
	},
	taskBoard: {
		url: `${config.API_URL}/lqa-game/system/taskInfo/getTaskBoard?versionNum=`,
		name: "获取所有任务看板信息",
		get: function (projectNum, taskType,serachModel) {
			return http.get(this.url + projectNum + "&taskType=" + taskType+"&serachModel="+serachModel);

		},
	},
	getTaskQuestion: {
		url: `${config.API_URL}/lqa-game/system/comment/question/getMyTaskQuestion?taskId=`,
		name: "获取所有任务问题集合",
		get: function (param) {
			return http.get(this.url +param);

		},
	},
	saveTaskQuestion: {
		url: `${config.API_URL}/lqa-game/system/comment/question`,
		name: "获取所有任务问题集合",
		post: function (data) {
			return http.post(this.url ,data);

		},
	},
	getTaskCounts: {
		url: `${config.API_URL}/lqa-game/system/taskInfo/getTaskCount?taskId=`,
		name: "获取所有任务问题集合",
		get: function (param1) {
			return http.get(this.url +param1);

		},
	},

	getTaskFinished: {
		url: `${config.API_URL}/lqa-game/system/taskInfo/getTaskFinishCount?taskId=`,
		name: "获取所有任务问题集合",
		get: function (param1) {
			return http.get(this.url +param1);

		},
	},
}
